import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { SearchStepResultDc } from "@evergis/api";
import { CircularProgress } from "@evergis/ui";

import {
  FoundCount,
  FoundTitle,
  FoundTitleContainer,
  LayerSearchResultsContainer,
  LayersListSearchResultsContainer,
  ProgressContainer,
} from "./styled";
import { LayerSearchResults } from "./LayerSearchResults";
import { NothingFound } from "./NothingFound";
import { formatNumber } from "../../../../utils/formatNumber";
import { useLayersSearchContext } from "./context";
import { useProgress } from "../../../../hooks/scheduler/useProgress";
import { SearchMode } from "./types";

export const LayersListSearchResults: FC = () => {
  const { t } = useTranslation("layerList");

  const { taskId } = useLayersSearchContext();
  const { result, isTaskExecuting, isTaskCompleted } = useProgress(taskId);

  const stepResults: SearchStepResultDc[] = (result?.stepResults as SearchStepResultDc[])?.filter(
    ({ foundObjects }) => foundObjects > 0,
  );
  const totalCount = result?.outputObjectCount || 0;
  const isEmpty = totalCount === 0;

  return (
    <LayersListSearchResultsContainer>
      {!!stepResults?.length && (
        <>
          <FoundTitleContainer>
            <FoundTitle>{t("found")}</FoundTitle>
            <FoundCount>{formatNumber(totalCount)}</FoundCount>
          </FoundTitleContainer>
          <LayerSearchResultsContainer isTaskExecuting={isTaskExecuting}>
            {stepResults.map(({ layerName, foundObjects }) => (
              <LayerSearchResults key={layerName} layerName={layerName} foundObjects={foundObjects} />
            ))}
          </LayerSearchResultsContainer>
        </>
      )}
      {isTaskCompleted && isEmpty && <NothingFound searchMode={SearchMode.Objects} />}
      {isTaskExecuting && (
        <ProgressContainer>
          <CircularProgress />
        </ProgressContainer>
      )}
    </LayersListSearchResultsContainer>
  );
};
